import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { UIRouterModule } from '@uirouter/angular';

import { CoreWidgetsModule } from '../../widgets/core.widgets.module';
import { CoreFiltersModule } from '../../core/core.filters.module';
import { CoreServicesModule } from '../../core/core.services.module';
import { WIKI_STATES } from './wiki.routes.config';

import { WikiBrowseComponent } from './browse/wiki.browse.component';
import { WikiPageComponent } from './page/wiki.page.component';
import { WikiHeaderComponent } from './header/wiki.header.component';
import { WikiEditHelpModalComponent } from '../../widgets/wiki/edit-help/wiki.edit-help.modal.component';
import { WikiBrowseService } from './services/wiki.browse.service';
import { WikiCommentsComponent } from './comments/wiki.comments.component';

// WikiResolvesService is providedIn 'root'; the monitor/referrers/attachments content components
// moved to CoreWidgetsModule so the self-contained <wiki-container> can render them everywhere.
@NgModule({
    imports: [
        BrowserModule,
        FormsModule,
        HttpClientModule,
        CoreWidgetsModule,
        CoreFiltersModule,
        CoreServicesModule,
        UIRouterModule.forChild({ states: WIKI_STATES })
    ],
    providers: [
        WikiBrowseService
    ],
    declarations: [
        WikiBrowseComponent,
        WikiPageComponent,
        WikiHeaderComponent,
        WikiEditHelpModalComponent,
        WikiCommentsComponent,
    ]
})
export class WikiModule {
    constructor() { }
}
